/* Ponto de entrada da rota /inteligencia-educacional.

   Três exigências do carregador de rotas do AVA (src/layout/Main.js:62-98),
   todas obrigatórias — se qualquer uma faltar, a rota cai no catch e vira um
   redirect quebrado:
     1. o export default precisa ser um connect()(...), porque o Main lê
        `.default.WrappedComponent.defaultProps`;
     2. defaultProps.hideLayout precisa ser false, senão o .filter() descarta;
     3. o arquivo tem de ser alcançável por import('../pages/' + local).

   Sobre CSS: o wrapper .ie-root confina o Tailwind (todas as regras do
   styles/generated.css são prefixadas com ele, então nada vaza para o
   Bootstrap/CoreUI da plataforma). Ele NÃO é aplicado aqui, e sim dentro do
   PainelShell, em volta apenas do conteúdo portado — as cascas de cada painel
   usam CoreUI puro. Ver "Duas camadas de CSS" no README da feature. */

import React, { Component } from "react";

import { connect } from "react-redux";

import App from "./App";
import { PerfilProvider } from "./context/PerfilContext";
import Breadcrumb from "../../components/Breadcrumb";
import ProtectedRoute from "../../components/ProtectedRoute";

import "./styles/generated.css";

class InteligenciaEducacional extends Component {
  render() {
    return (
      <div className="d-flex flex-column align-items-left">
        {/* Quem abre a seção é o access_roles_links do papel; qual painel
            (professor, admin, gestor) continua decidido pelo papel ativo, no
            Guard do App. */}
        <ProtectedRoute routeId={this.props.currentRoute} />
        <Breadcrumb current={this.props.currentRoute} />
        <PerfilProvider>
          <App />
        </PerfilProvider>
      </div>
    );
  }
}

InteligenciaEducacional.defaultProps = {
  hideLayout: false,
  hideContainer: false
};

const mapStateToProps = state => ({
  user: state.user,
  general: state.general
});

export default connect(mapStateToProps)(InteligenciaEducacional);
